const SectionCodeShare = Class(
  /**
   * @lends {SectionCodeShare#}
   */
  {
    route () {
      switch (this.url.shift()) {
        case 'scan':
          return new SectionCodeShareScan;
        case 'code':
          return new SectionCodeShareCode;
        case 'vilks':
          return new SectionCodeShareVilks;
        default:
          return new SectionCodeHome;
      }
    }
  },
  Section
);

const SectionCodeBase = Class(
  /**
   * @lends {SectionCodeBase#}
   */
  {
    bodyClass: 'hide-tablet-footer',
    __construct () {
      this.node = mkE({
        tag: 'div',
        id: 'SectionCodeShare',
        className: 'container'
      }).append(this.layout.ct());
    }
  },
  Section
);

const SectionCodeHome = Class(
  /**
   * @lends {SectionCodeHome#}
   */
  {
    draw () {
      if (this.url.get.v('team')) {
        localStorage.setItem('codeshare_team', this.url.get.v('team'));
        localStorage.setItem('codeshare_team_uid', D.ID);
      }
      this.content = mkE({
        tag: 'div',
        className: 'content content-home',
        els: [
          new SectionCodeBase.LangSelect({
            languages: {
              'lv': 'LV',
              'en': 'EN'
            }
          }),
          {
            tag: 'div',
            className: 'task-icon'
          },
          {
            tag: 'h1',
            text: t('codeshare.landing.title')
          },
          {
            tag: 'p',
            className: 'h1-p',
            text: t('codeshare.landing.text')
          },
          {
            tag: 'a',
            className: 'button button-pink',
            text: t('codeshare.landing.button'),
            href: '/code-share/scan'
          }
        ]
      }).append(this.node);
      D.addJS('/assets/instascan/qr-scanner.umd.min.js');
      this.ready();
    }
  },
  SectionCodeBase
);

const SectionCodeShareScan = Class(
  /**
   * @lends {SectionCodeShareScan#}
   */
  {
    cache: false,
    cacheBack: false,
    draw () {
      this.content = mkE({
        tag: 'div',
        className: 'content',
        els: [
          {
            tag: 'div',
            id: 'scan',
            els: [
              {
                tag: 'div',
                className: 'video-container',
                els: [
                  this._previewNode = mkE({
                    tag: 'video'
                  }),
                  {
                    tag: 'div',
                    className: 'info',
                    els: [
                      this._targetNode = mkE({
                        tag: 'div',
                        className: 'target'
                      })
                    ]
                  }
                ]
              },
              {
                tag: 'div',
                className: 'overlay',
                els: [
                  {
                    tag: 'form',
                    onsubmit: this._onEnterCode,
                    els: [
                      this._switchCameraButton = mkE({
                        tag: 'a',
                        className: 'switch',
                        onclick: this.switchCameras,
                        style: {
                          display: 'none'
                        }
                      }),
                      this._input = new T.Form.Input({
                        placeholder: t('codeshare.scan.input-placeholder'),
                        onFocus: D.closure(this, function () {
                          this._input.error(false);
                        }),
                        onKeyUp: D.closure(this, function () {
                          if (this._input.value().length >= 5) {
                            addClassName(this._inputButton, 'button-pink');
                            removeClassName(this._inputButton, 'button-gray');
                          } else {
                            removeClassName(this._inputButton, 'button-pink');
                            addClassName(this._inputButton, 'button-gray');
                          }
                        })
                      }),
                      this._inputButton = mkE({
                        tag: 'button',
                        type: 'submit',
                        className: 'button button-gray',
                        text: t('codeshare.scan.submit')
                      })
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }).append(this.node);
      this.ready();
    },

    onShow() {
      D.addJS('/assets/instascan/qr-scanner.umd.min.js', this._onLoadScanner);
    },

    _activeCamera: 0,

    switchCameras () {
      QrScanner.listCameras().then(cameras => {
        if (this._activeCamera + 1 >= cameras.length) {
          this._activeCamera = 0;
        } else {
          this._activeCamera++;
        }
        this._scanner.setCamera(cameras[this._activeCamera].id);
      });
    },

    _removeTargetText () {
      if (this._targetNodeText) {
        this._targetNodeText.remove();
        this._targetNodeText = null;
      }
    },

    _onLoadScanner () {
      try {
        this._scanner = new QrScanner(
          this._previewNode,
          result => {
            if (result.data === 'https://roadgames.app.link/e/V3slshalWJb') {
              window.location = result.data;
              return;
            }
            const match = result.data.match(/code-share\/code\/([\w\d]{5})/);
            const code = match ? match[1] : null;
            if (this._validateCode(code)) {
              this._openCode(code);
            } else {
              this._onInvalidCode();
            }
          },
          {
            preferredCamera: 'environment',
            onDecodeError: () => {
              // nobody cares
            }
          }
        );
        this._scanner.start().then(() => {
          QrScanner.listCameras().then(cameras => {
            if (cameras.length > 1) {
              this._switchCameraButton.style.display = '';
              for (let i = 0; i < cameras.length; i++) {
                const camera = cameras[i];
                if (/rear|back|environment/i.test(camera.label)) {
                  this._activeCamera = i;
                  break;
                }
              }
            } else if (!cameras.length) {
              alert('No camera detected');
            }
          });
        });
      } catch (e) {
        console.error(e);
      }
    },

    _onInvalidCode () {
      this._removeTargetText();
      this._targetNodeText = mkE({
        tag: 'div',
        className: 'text-danger',
        text: t('codeshare.scan.invalid-code')
      }).append(this._targetNode);
      setTimeout(this._removeTargetText, 3000);
    },

    _onEnterCode (e) {
      e.preventDefault();
      const code = this._input.value();
      if (this._validateCode(code)) {
        this._openCode(code);
      } else {
        this._input.error(true);
        this._onInvalidCode();
      }
    },

    _validateCode (code) {
      return code?.length === 5;
    },

    _openCode (code) {
      this._scanner?.destroy();
      this._scanner = null;
      Section.navigate('/' + D.LANG + '/code-share/code/' + code, {
        popState: true
      });
    },

    onLeave () {
      this._scanner?.destroy();
      this._scanner = null;
    }
  },
  SectionCodeBase
);

const SectionCodeShareCode = Class(
  /**
   * @lends {SectionCodeShareSuccess#}
   */
  {
    route () {
      this._code = this.url.shift();
    },

    draw () {
      this.content = mkE({
        tag: 'div',
        className: 'content content-code'
      }).append(this.node);

      const uid = Number(localStorage.getItem('codeshare_team_uid'));
      let teamCode = '';
      if (D.ID === uid) {
        teamCode = localStorage.getItem('codeshare_team');
      }
      if (!D.ID && teamCode) {
        this._mClaimCode = new DR.codeshare.ClaimCodeWithTeamCode();
        this._mClaimCode.onErrorAutoDisabled = true;
        this._mClaimCode.onLoad = this._mClaimCodeRe;
        this._mClaimCode.onError = this._mClaimCodeError;
        this._mClaimCode.team = teamCode;
        this._mClaimCode.code = this._code;
        this._mClaimCode.call();
      } else {
        this._mCheckCode = new DR.codeshare.CheckCode();
        this._mCheckCode.onErrorAutoDisabled = true;
        this._mCheckCode.onLoad = this._mCheckCodeRe;
        this._mCheckCode.onError = this._mCheckCodeError;
        this._mCheckCode.code = this._code;
        this._mCheckCode.call();
      }

      this.ready();
    },

    _mCheckCodeError () {
      this._onError(this._mCheckCode.error);
    },

    _mCheckCodeRe () {
      this._mClaimCode = new DR.codeshare.ClaimCode();
      this._mClaimCode.onErrorAutoDisabled = true;
      this._mClaimCode.onLoad = this._mClaimCodeRe;
      this._mClaimCode.onError = this._mClaimCodeError;
      this._mClaimCode.code = this._code;
      this._mClaimCode.call({ eventId: this._mCheckCode.re.eventId });
    },

    _mClaimCodeRe () {
      const m = this._mClaimCode;
      if (m.re.error) {
        this._onError(m.re.error, m.re);
        return;
      }
      clearNode(this.content);
      mkE.appendTypeElement(this.content, [
        mkELottie({
            tag: 'div',
            className: 'task-success'
          }, {
            path: '/assets/lottie/codeshare_success_sZCj4jl5o5.json',
            loop: false
          }
        ),
        {
          tag: 'h1',
          className: 'mb-0',
          text: t('codeshare.success.title')
        },
        {
          tag: 'p',
          className: 'text-center',
          text: t('codeshare.success.text')
            .replace('%COUNT%', m.re.count)
            .replace('%TEAMS%', m.re.teams)
            .replace('%POINTS%', m.re.points)
        },
        {
          tag: 'a',
          className: 'button button-pink',
          text: t('codeshare.scan-more'),
          href: D.url('/code-share')
        },
        {
          tag: 'a',
          className: 'button button-link',
          text: t('codeshare.back-to-app'),
          href: 'roadgames://open'
        }
      ]);
    },

    _mClaimCodeError () {
      this._onError(this._mClaimCode.error);
    },

    _onError (error, re = null) {
      clearNode(this.content);
      if (error === 'vilks') {
        mkE({
          tag: 'div',
          className: 'vilki',
          els: [
            {
              tag: 'div',
              className: 'vilki-icon'
            },
            {
              tag: 'h1',
              className: 'mb-0',
              text: t('codeshare.vilks.title')
            },
            {
              tag: 'p',
              className: 'text-center mb-4',
              text: t(`codeshare.vilks.text`)
            },
            new T.SocialIcons({
              socials: ['tk', 'ig', 'fb', 'in'],
              text: '',
              title: ''
            }),
            {
              tag: 'h3',
              className: 'mb-4',
              text: t('codeshare.vilks.participant')
            },
            {
              tag: 'a',
              className: 'button button-pink',
              text: t('web.og.sign-in.title'),
              onclick: function () {
                window.location = '/sign-in?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
              }
            }
          ]
        }).append(this.content);
        return;
      }
      const errorKeys = {
        'auth': 'check_login',
        'invalid request': 'check_login',
        'no code share': 'check_login',
        'invalid code': 'invalid_code',
        'cannot claim own': 'cannot_claim_own',
        'already claimed': 'already_claimed',
        'no event access': 'check_login',
        'event not active': 'event_not_active',
        'no team': 'check_login',
        'team not exists': 'check_login',
        'claimed team not exists': 'invalid_code',
        'invalid distance': 'invalid_distance',
        'default': 'system_error'
      };
      const errorKey = errorKeys[error] || errorKeys['default'];
      mkE.appendTypeElement(this.content, [
        {
          tag: 'div',
          className: 'task-icon'
        },
        {
          tag: 'h1',
          className: 'mb-0',
          text: t('codeshare.error-title')
        },
        {
          tag: 'p',
          className: 'text-center',
          text: t(`codeshare.errors.${errorKey}`)
            .replace('%COUNT%', re?.count)
            .replace('%TEAMS%', re?.teams)
            .replace('%POINTS%', re?.points)
        },
        (() => {
          if (errorKey === 'check_login') {
            return {
              tag: 'a',
              className: 'button button-pink',
              text: t('web.og.sign-in.title'),
              onclick: function () {
                window.location = '/sign-in?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
              }
            };
          }
          return {
            tag: 'a',
            className: 'button button-gray',
            text: t('codeshare.back'),
            onclick: function () {
              Section.navigate('/code-share');
            }
          };
        })()
      ]);
    }
  },
  SectionCodeBase
);

const SectionCodeShareVilks = Class(
  /**
   * @lends {SectionCodeShareSuccess#}
   */
  {
    draw () {
      this.content = mkE({
        tag: 'div',
        className: 'content',
        els: [
          {
            tag: 'div',
            className: 'vilki',
            els: [
              {
                tag: 'div',
                className: 'vilki-icon'
              },
              {
                tag: 'h1',
                className: 'mb-4',
                text: 'This one should work '
              },
              {
                tag: 'p',
                className: 'text-center mb-4',
                text: 'Here is a 50% discount code on any Roadgames game. Valid till the end of summer (31st Aug.)'
              },
              {
                tag: 'div',
                className: 'discount-code mb-4',
                text: 'FIXEDIT'
              },
              new T.SocialIcons({
                socials: ['tk', 'ig', 'fb', 'in'],
                text: '',
                title: ''
              }),
            ]
          }
        ]
      }).append(this.node);
      this.ready();
    }
  },
  SectionCodeBase
);

SectionCodeBase.LangSelect = Class(
  {
    __construct (par) {
      this.par = par;
      this.node = mkE({
        tag: 'label',
        className: 'lang-selector lang-' + D.LANG,
        els: [
          this._langInput = new T.Form.Select({
            onChange: this._onChangeInput,
            value: D.LANG,
            options: (() => {
              let els = [];
              for (let i in par.languages) {
                if (par.languages.hasOwnProperty(i)) {
                  const language = par.languages[i];
                  els.push({
                    value: i,
                    caption: language
                  });
                }
              }
              return els;
            })(),
            border: true
          })
        ]
      });
    },
    _onChangeInput () {
      const lang = this._langInput.value();
      removeClassName(this.node, 'lang-' + D.Lang);
      addClassName(this.node, 'lang-' + lang);
      window.location = D.url(window.location.pathname.split('/').slice(2).join('/') + window.location.search, lang);
    }
  },
  mkE.Base
);